// Menu Drawer Enhancement - Add body class when menu is open
(function() {
  'use strict';
  
  function initMenuDrawerEnhancement() {
    const menuDrawerContainer = document.querySelector('.menu-drawer-container');
    
    if (!menuDrawerContainer) return;
    
    // Monitor the details element for open/close
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (menuDrawerContainer.hasAttribute('open')) {
            document.body.classList.add('menu-drawer-open');
            console.log('Menu drawer opened');
          } else {
            document.body.classList.remove('menu-drawer-open');
            console.log('Menu drawer closed');
          }
        }
      });
    });
    
    // Start observing
    observer.observe(menuDrawerContainer, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Also handle toggle events
    menuDrawerContainer.addEventListener('toggle', function() {
      if (this.open) {
        document.body.classList.add('menu-drawer-open');
      } else {
        document.body.classList.remove('menu-drawer-open');
      }
    });
    
    // Check initial state
    if (menuDrawerContainer.hasAttribute('open')) {
      document.body.classList.add('menu-drawer-open');
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDrawerEnhancement);
  } else {
    initMenuDrawerEnhancement();
  }
})();